/**
 * SYSTEM SETTINGS MODULE — Sync Settings.
 * Connect Google Sheets to feed the Depletions, Inventory and Retail Product
 * Finder screens. Lives in System Settings (workspace owner/admin only) so a
 * standard user can't disconnect a configured sync. The actual data write
 * happens server-side via the `sheets-sync` edge function (a documented
 * cross-module boundary).
 *
 * Each dataset is its own connection, so a tenant can point them all at one
 * spreadsheet (different tabs) or keep them in separate files — the key is
 * (account, provider, dataset), not the spreadsheet id.
 */

import GoogleSheetsPanel from "./GoogleSheetsPanel.jsx";
import RetailLocationsPanel from "./RetailLocationsPanel.jsx";

export default function SyncSettingsSection() {
  return (
    <section className="settings-card wide">
      <h2 style={{ marginTop: 0 }}>Sync Settings</h2>
      <p className="muted">
        Connect a Google Sheet to keep these screens up to date automatically.
        Rows are matched to your Product SKUs and States the same way a file
        import is, so set those up first. Each sync replaces the dataset with the
        sheet’s current contents.
      </p>

      <GoogleSheetsPanel dataset="depletions" label="Depletions — Google Sheet" />
      <GoogleSheetsPanel dataset="inventory" label="Inventory — Google Sheet" />

      {/* Retail locations own their source choice (depletions vs. a sheet), so
          they get a wrapper rather than a bare sheet panel. */}
      <RetailLocationsPanel />
    </section>
  );
}
